import { DEFAULT_EVENT_TICKER } from '../defaults';
import { EVENT_REQUESTS } from '../dataSource';
import type { WidgetSchema } from '../types';

export const symbolDetail: WidgetSchema = {
    meta: {
        id: 'symbol-detail',
        category: 'symbol-details',
        categoryTitle: 'Symbol Details',
        title: 'Symbol Detail',
        description: 'An inline market pill you can drop into a sentence or headline.',
        status: 'live',
    },
    fields: [
        {
            kind: 'event-search',
            key: 'eventTicker',
            label: 'Event',
            defaultValue: DEFAULT_EVENT_TICKER,
            allowManualTicker: true,
        },
        // Defaults to the most-traded market (top price) rather than the first one,
        // which avoids landing on a 0c market.
        {
            kind: 'market-select',
            key: 'marketId',
            label: 'Market',
            mode: 'single',
            autoSelectTopN: 1,
            defaultValue: [],
        },
        {
            kind: 'utm',
            key: 'utm',
            label: 'Marketing (UTM)',
            defaultValue: { utmSource: '', utmCampaign: '', promoCode: '' },
        },
    ],
    preview: { kind: 'event-loader' },
    embed: { kind: 'event-loader', fixed: { widgetSize: 'inline' } },
    dataSource: {
        summary:
            'The pill shows one market’s odds; the event endpoint returns that market alongside the rest of its event.',
        requests: EVENT_REQUESTS,
    },
};
